import { render, staticRenderFns } from "./PurseIcon.vue?vue&type=template&id=1ac9c91e&"
import script from "./PurseIcon.vue?vue&type=script&lang=ts&"
export * from "./PurseIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports